import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'playground-shafer',
    path: '/playground-shafer',
    component: () => import('@/pages/Development/PlaygroundShafer.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground',
      description: 'Playground',
    }),
  },
  {
    name: 'playground-gustavo',
    path: '/playground-gustavo',
    component: () => import('@/pages/Development/PlaygroundGustavo.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground Gustavo',
      description: 'Playground Gustavo',
    }),
  },
  {
    name: 'playground-duarte',
    path: '/playground-duarte',
    component: () => import('@/pages/Development/PlaygroundDuarte.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground Duarte',
      description: 'Playground Duarte',
    }),
  },
  {
    name: 'playground-camel',
    path: '/playground-camel',
    component: () => import('@/pages/Development/PlaygroundCamel.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground Camel',
      description: 'Playground Camel - Job Search Experiments',
    }),
  },
  {
    name: 'playground-slava',
    path: '/playground-slava',
    component: () => import('@/pages/Development/PlaygroundSlava.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground Slava',
      description: 'Playground Slava',
    }),
  },
  {
    name: 'playground-resume-scan',
    path: '/playground-resume-scan',
    component: () => import('@/pages/Development/PlaygroundResumeScan.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground ResumeScan',
      description: 'Playground ResumeScan',
    }),
  },
  {
    name: 'playground-resume-scan-single-prompt',
    path: '/playground-resume-scan-single-prompt',
    component: () => import('@/pages/Development/PlaygroundResumeScanSinglePrompt.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground ResumeScan',
      description: 'Playground ResumeScan',
    }),
  },
  {
    name: 'playground-markdown-docx',
    path: '/playground-markdown-docx',
    component: () => import('@/pages/Development/PlaygroundMarkdownToDocx.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Markdown to DOCX Converter',
      description: 'Enhanced Markdown to DOCX converter with professional templates',
    }),
  },
  {
    name: 'components',
    path: '/components',
    component: () => import('@/pages/Development/ComponentGallery.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: false,
      hideDistractions: false,
      robots: 'noindex',
      title: 'Development Playground Gustavo',
      description: 'Playground Gustavo',
    }),
  },
]

export default routes
